import Scene from "../../lib/services/scene/scene";
import Stage from "../../lib/services/stage/stage";
import InputService,{Keys} from "../../lib/services/input/inputservice";
import Treehouse from "./treehouse";
import Doghouse from "./doghouse";
import Dogbowl from "./bowl/dogbowl";
import Sky from "./sky/sky";
import Fence from "./fence/fence";
import Puppy from "./puppy/puppy";
import Ground from "./ground/ground";
import DioramaCamera from "../../lib/services/scene/diorama_camera";
import DioramaCameraPlacement from "../../lib/services/scene/diorama_camera_placement";
import DioramaCameraControl from "../../lib/services/scene/diorama_camera_control";
import Frisbee from "./frisbee/frisbee";
import Bone from "./bone/bone";
import MushroomPatch from "./mushroom/mushroompatch";
import BoneFetchController from "./puppy/bone_fetch_controller";
import FrisbeeController from "./puppy/frisbee_controller";
import Reticle from "./reticle/reticle";
import Video from "./video/video";
import Scrim from "./video/scrim";
import Scan from "./video/scan";
import BoneFollowCamera from "./puppy/bone_follow_camera";
import FrisbeeFollowCamera from "./puppy/frisbee_follow_camera";
import RewardManager from "./reward/reward_manager";

export default class FrisbeedogScene extends Scene
{
    ground:Ground;
    treehouse:Treehouse;
    doghouse:Doghouse;
    dogbowl:Dogbowl;
    sky:Sky;
    mushroom_patch:MushroomPatch;
    puppy:Puppy;
    camera:DioramaCamera;
    camera_control:DioramaCameraControl;
    cam_placement:DioramaCameraPlacement;
    frisbee:Frisbee;
    bone_fetch:BoneFetchController;
    input:InputService;
    private fetch_camera_active: boolean;
    private fetch_camera_linger: number;
    private last_fetch_phase: string;
    restoring_camera: boolean;
    camera_restore_t: number;

     reticle:Reticle;
     frisbee_controller:FrisbeeController;
     video:Video;
     scrim:Scrim;
     scan:Scan;

     bone_follow_camera: BoneFollowCamera;
     frisbee_follow_camera: FrisbeeFollowCamera;

     reward_manager:RewardManager;
    
        private activity_fetch_unlocked: boolean;
        private activity_walk_dog_unlocked: boolean;
        private activity_tire_swing_unlocked: boolean;
        private activity_hide_n_seek_unlocked: boolean;
        private activity_frisbee_unlocked: boolean;

        private current_activity: string;
    
    constructor()
    {
        
        super("frisbeedog");

        this.activity_fetch_unlocked = false;
        this.activity_walk_dog_unlocked = false;
        this.activity_tire_swing_unlocked = false;
        this.activity_hide_n_seek_unlocked = false;
        this.activity_frisbee_unlocked = false;

        this.current_activity = "";

        //test data
       /* this.activity_fetch_unlocked = true;
        this.activity_walk_dog_unlocked = true;
        this.activity_tire_swing_unlocked = true;
        this.activity_hide_n_seek_unlocked = true;
        this.activity_frisbee_unlocked = true;
        this.current_activity = "fetch";*/


        this.input = Stage.instance().input_service;
        this.camera = new DioramaCamera();



        //even more
        this.camera.set_target(0.0, 0.5, 2.8);
        this.camera.set_style_angle(Math.PI * 0.03, 0.08);
        this.camera.set_fov_y(Math.PI / 8.5);
        this.camera.set_distance(6.0);
        this.cam_placement = new DioramaCameraPlacement(this.camera);
        this.camera.set_distance_bounds(1.0,30.0);
        this.camera.set_distance(8.0);

        this.camera_control = new DioramaCameraControl(this.camera);
        this.camera_control.set_pan_bounds(-4.0, 4.0);
        this.camera_control.set_sensitivity(0.008, 0.010);
        this.camera_control.set_smoothing(0.25);

        this.sky= new Sky("sky");
        this.add(this.sky);

        this.ground= new Ground("ground");
        this.add(this.ground);

        this.treehouse= new Treehouse("treehouse");
        this.add(this.treehouse);
         this.mushroom_patch = new MushroomPatch("patchs");
         this.add(this.mushroom_patch);
        
        this.puppy = new Puppy ("puppy");
        this.add(this.puppy);

       this.reticle = new Reticle("reticle");
       this.add(this.reticle);
        this.frisbee = new Frisbee("frisbee");
        this.add(this.frisbee);

         //this.bone = new Bone("bone");
         //this.add(this.bone);
        //this.set_bone_position();


        this.doghouse= new Doghouse("doghouse");
        this.add(this.doghouse);
        this.dogbowl= new Dogbowl("dogbowl");
        this.add(this.dogbowl);
        

        this.bone_fetch = new BoneFetchController("bonefetch",this.puppy);
        this.add(this.bone_fetch);

        this.fetch_camera_active = false;
        this.fetch_camera_linger = 0.0;
        this.last_fetch_phase = "idle";
        
        this.restoring_camera = false;
        this.camera_restore_t = 0.0;

        this.frisbee_controller = new FrisbeeController("frisbee_c",this.puppy,this.camera,this.reticle,this.frisbee);
        this.add(this.frisbee_controller);

        //always last is video

        this.scrim = new Scrim("scrim");
        this.add(this.scrim);

         this.video = new Video("video");
        this.add(this.video);

         this.scan = new Scan("scan");
         this.add(this.scan);

         this.bone_follow_camera = new BoneFollowCamera(
            this.camera,
            this.camera_control,
            this.puppy,
            this.bone_fetch
            );

            this.frisbee_follow_camera = new FrisbeeFollowCamera(
                this.camera,
                this.camera_control,
                this.puppy,
                this.frisbee,
                () => this.frisbee_controller.fetch_controller
                );
                                
         this.reward_manager = new RewardManager();
    }
    
    prepare(device: GPUDevice)
    {
        this.internal_prepare(device,this.camera);
    }

    override query_string(key: string): string
    {
        if (key == "current_activity")
        {
            return this.current_activity;
        }
        return "";

    }

    override query_bool(key: string): boolean
    {
        if (key == "activity_fetch_unlocked")
        {
            return this.activity_fetch_unlocked;
        }
        else if (key == "activity_walk_dog_unlocked")
        {
            return this.activity_walk_dog_unlocked;
        }
        else if (key == "activity_tire_swing_unlocked")
        {
            return this.activity_tire_swing_unlocked;
        }
        else if (key == "activity_hide_n_seek_unlocked")
        {
            return this.activity_hide_n_seek_unlocked;
        }
        else if (key == "activity_frisbee_unlocked")
        {
            return this.activity_frisbee_unlocked;
        }
        return false;

    }

    override set_string(key:string,str:string):void
    {
        if (key == "current_activity")
        {
            console.log("frisbee-scene", str);
            if (
                str == "fetch" ||
                str == "walk_dog" ||
                str == "tire_swing" ||
                str == "hide_n_seek" ||
                str == "frisbee"
            )
            {
                this.current_activity = str;
            }
        }
    }

    override query_number(key: string): number | null
    {
        if(key == "bone_count")
        {
                return this.bone_fetch.get_bone_count();
        }
        else if(key == "care_cleanliness")
        {
            return 100;
        }
        else if(key == "care_happiness")
        {
            return 100;
        }
        else if(key == "care_energy")
        {
            return 100;
        }

        return 0;
    }

    ui_message(cmd: string, msg: string)
    {
        super.ui_message(cmd,msg);
        
        console.log("ui_message: "+cmd);
       // this.puppy.run_debug_sequence();

       if(cmd=="reward")
       {
            //"bone" for bones
           const ret =  this.reward_manager.show_next('reward');
           if(ret)
           {
             if(ret== "walk_dog") this.activity_walk_dog_unlocked = true;
             else if(ret== "tire_swing") this.activity_tire_swing_unlocked = true;
             else if(ret== "hide_n_seek") this.activity_hide_n_seek_unlocked = true;
             else if(ret== "frisbee") this.activity_frisbee_unlocked = true;
             
           }
       }
       else if(cmd == "sticker")
       {
           this.reward_manager.show_next('bones');
           this.bone_fetch.add_bones(7); 
           this.activity_fetch_unlocked  = true;
           this.current_activity = "fetch";      
       }
       
    
    
    } 

    check_debug_ui(delta_time:number)
    {
         if(this.input.was_key_pressed(Keys.Digit9))
         {
            this.ui_message("sticker","500");
         }   

    }

    tick(delta_time: number)
    {
        if(!this.frisbee_controller || !this.frisbee_controller.fetch_controller) return;

        this.check_debug_ui(delta_time);

    const fetchBusy = this.bone_follow_camera.is_busy();

if (this.current_activity == "fetch") {
  this.bone_fetch.enabled = true;
  this.frisbee_controller.disable();

  if (this.bone_follow_camera.is_busy()) {
    this.bone_follow_camera.tick(delta_time);
  } else if (this.camera_control.is_enabled()) {
    this.camera_control.tick(delta_time);
  }
}
else if (this.current_activity == "frisbee") {
  this.bone_fetch.enabled = fetchBusy;
  this.frisbee_controller.enable();

  if (this.frisbee_follow_camera.is_busy()) {
    this.frisbee_follow_camera.tick(delta_time);
  } else if (this.bone_follow_camera.is_busy()) {
    this.bone_follow_camera.tick(delta_time);
  } else if (this.camera_control.is_enabled()) {
    this.camera_control.tick(delta_time);
  }
}
else {
  this.bone_fetch.enabled = fetchBusy;
  this.frisbee_controller.disable();

  if (this.bone_follow_camera.is_busy()) {
    this.bone_follow_camera.tick(delta_time);
  } else if (this.camera_control.is_enabled()) {
    this.camera_control.tick(delta_time);
  }
}
   
        super.tick(delta_time);
    }
      

    
   
}

